(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-floating-page-tools"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-sp-scroll]');

    if (!control) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = control.dataset.spScroll === 'top' ? 0 : document.documentElement.scrollHeight;

    window.scrollTo({ top, behavior: reducedMotion ? 'auto' : 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

})();
